import { Coordinate } from '@/Types/coordinate';
export default class CameraSummaryModel {

  cameraId: string;
  cameraName: string;
  addedDateTime: Date;
  coordinate: Coordinate;
  isRequestLastAccessed: boolean;

  constructor(serverModel: any, previousCameraId: string | null) {

    this.isRequestLastAccessed = serverModel.cameraId === previousCameraId;
    this.cameraId = serverModel.cameraId;
    this.cameraName = serverModel.cameraName;
    this.addedDateTime = serverModel.addedDateTime;
    this.coordinate = {
      latitude: serverModel.coordinate.latitude,
      longitude: serverModel.coordinate.longitude
    };
  }
}
